<script setup lang="ts">
import { getAnalyticsTracker } from "@/tracking/analytics/plugin.ts";
import GbButton from "@/components/GbButton.vue";

const props = defineProps({
  buttonId: {
    String,
    required: true
  },
  eventName: {
    type: String,
    required: false
  },
  eventContext: {
    type: Object,
    required: false
  }
})

let handleClick:  () => void
if (props.eventContext) {
  const analytics = getAnalyticsTracker().getChildContext(props.eventContext)
  handleClick = () => analytics.sendEvent(props.eventName || 'undefined event')
} else {
  handleClick = () => console.log('no event defined on node')
}

</script>

<template>
  <div class="rounded my-6 w-fit border border-gray-400 bg-gray-100 px-6 py-6 font-default shadow-md">
    <GbButton
      id="buttonId"
      @click="handleClick"
      gb-theme="bluePrimary">
      {{ buttonId }}
    </GbButton>
    <slot/>
  </div>
</template>

<style scoped>

</style>